module.exports = __webpack_public_path__ + "static/brand02-a0dbe1ceae54c92ca21569063597b630.png";